"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportJobAccountLinkClient = void 0;
var BaseClient_1 = require("../../BaseClient");
var TransportJobAccountLinkClient = /** @class */ (function (_super) {
    __extends(TransportJobAccountLinkClient, _super);
    function TransportJobAccountLinkClient(axiosClient) {
        var _this = _super.call(this, axiosClient) || this;
        _this.cancel = _this.cancel.bind(_this);
        _this.revoke = _this.revoke.bind(_this);
        _this.create = _this.create.bind(_this);
        _this.accept = _this.accept.bind(_this);
        _this.reject = _this.reject.bind(_this);
        _this.list = _this.list.bind(_this);
        _this.replace = _this.replace.bind(_this);
        _this.retrieve = _this.retrieve.bind(_this);
        _this.listMessages = _this.listMessages.bind(_this);
        return _this;
    }
    /**
     * Cancels a TransportJobAccountLink resource.
     * Throws CancelTransportJobAccountLinkError.
     */
    TransportJobAccountLinkClient.prototype.cancel = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            data: {},
                            method: 'POST',
                            url: "/transport_job_account_links/".concat(args.id, "/cancel")
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Revokes a TransportJobAccountLink resource.
     */
    TransportJobAccountLinkClient.prototype.revoke = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            data: {},
                            method: 'POST',
                            url: "/transport_job_account_links/".concat(args.id, "/revoke")
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Accepts a TransportJobAccountLink resource.
     * Returns a redirect url if payment is required
     */
    TransportJobAccountLinkClient.prototype.accept = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            data: {},
                            method: 'POST',
                            url: "/transport_job_account_links/".concat(args.id, "/accept")
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Rejects a TransportJobAccountLink resource.
     * Used by non-guaranteed / non-prepaid flow
     */
    TransportJobAccountLinkClient.prototype.reject = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            data: {},
                            method: 'POST',
                            url: "/transport_job_account_links/".concat(args.id, "/reject")
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a TransportJobAccountLink resource.
     */
    TransportJobAccountLinkClient.prototype.create = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            data: data,
                            method: 'POST',
                            url: '/transport_job_account_links'
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves a single TransportJobAccountLink resource.
     */
    TransportJobAccountLinkClient.prototype.retrieve = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            method: 'GET',
                            url: "/transport_job_account_links/".concat(args.id)
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Replaces the TransportJobAccountLink resource. Only for ROLE_ADMIN_ACCOUNT.
     */
    TransportJobAccountLinkClient.prototype.replace = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            method: 'PUT',
                            url: "/transport_job_account_links/".concat(args.id),
                            data: { driver_user: args.driver_user }
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves the collection of TransportJobAccountLink resources.
     */
    TransportJobAccountLinkClient.prototype.list = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            method: 'GET',
                            url: '/transport_job_account_links',
                            params: {
                                state: (_a = params.state) === null || _a === void 0 ? void 0 : _a.join(','),
                                transport_job_state: (_b = params.transport_job_state) === null || _b === void 0 ? void 0 : _b.join(','),
                                date_from: params.date_from,
                                date_to: params.date_to,
                                presentation: params.presentation,
                                page: params.page,
                                // Not ideal, but used by core
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                'transport_job.short_id': params.tj_short_id,
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                'order[pickup_date]': params.order_pickup_date
                            }
                        })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * List a full conversation by tjal id.
     */
    TransportJobAccountLinkClient.prototype.listMessages = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            method: 'GET',
                            url: "/transport_job_account_links/".concat(args.id, "/messages")
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TransportJobAccountLinkClient;
}(BaseClient_1.BaseClient));
exports.TransportJobAccountLinkClient = TransportJobAccountLinkClient;
